(() => {
  const labelsElement = document.querySelector('[data-pco-mobile-labels]');
  if (!labelsElement || labelsElement.dataset.initialized) return;
  labelsElement.dataset.initialized = 'true';
  const labels = JSON.parse(labelsElement.textContent);
  const mobile = window.matchMedia('(max-width: 749px)');
  let restore = [];

  function fold(nodes, label, kind) {
    if (!nodes.length) return;
    const details = document.createElement('details');
    details.className = `pco-mobile-fold pco-mobile-fold--${kind}`;
    const summary = document.createElement('summary');
    summary.textContent = label;
    details.append(summary);
    nodes[0].before(details);
    const positions = nodes.map(node => {
      const anchor = document.createComment('pco-mobile-position');
      node.before(anchor);
      details.append(node);
      return { node, anchor };
    });
    restore.push(() => {
      positions.forEach(({ node, anchor }) => anchor.replaceWith(node));
      details.remove();
    });
  }

  function description() {
    const description = document.querySelector('.md-tabs__description');
    if (!description || description.textContent.trim().length < 900) return;
    let container = description;
    const blocks = element => [...element.children].filter(child =>
      !['STYLE', 'SCRIPT'].includes(child.tagName) && child.textContent.trim());
    while (blocks(container).length === 1 && blocks(container)[0].tagName === 'DIV') {
      container = blocks(container)[0];
    }
    const children = blocks(container);
    if (children.length < 4) return;
    const boundary = children[2];
    const remaining = [];
    let node = boundary;
    while (node) {
      remaining.push(node);
      node = node.nextSibling;
    }
    fold(remaining, labels.description, 'description');
  }

  function update() {
    restore.reverse().forEach(undo => undo());
    restore = [];
    if (!mobile.matches) return;
    const reserve = document.querySelector('.product-main .custom-form__group:has(.custom-btn--reserve)');
    if (reserve) {
      const payment = document.querySelector('.product-main .product-app:has(klarna-placement)');
      fold([reserve, payment].filter(Boolean), labels.payments, 'payments');
    }
    description();
    document.querySelectorAll('[data-pco-mobile-fold]').forEach(element => {
      const kind = element.dataset.pcoMobileFold;
      const section = element.closest('.shopify-section');
      if (section && labels[kind]) fold([section], labels[kind], 'section');
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update, { once: true });
  else update();
  mobile.addEventListener('change', update);
  document.addEventListener('shopify:section:load', update);
})();
